import SiteContainer from 'components/Site/SiteContainer'
import SiteData from 'components/Site/SiteData'

export default {
  Container: SiteContainer,
  Data: SiteData,
}
